import { useRef } from "react";
import React = require("react");

export const ButtonTimer = (props: { onClick: () => void; }) => {
    const [counter, setCounter] = React.useState(0);
    const intervalRef = useRef(null);

    React.useEffect(() => () => stopCounter(), []);
    const startCounter = () => {
        if (intervalRef.current)
            return;

        intervalRef.current = setInterval(() => {
            setCounter((prevCounter) => prevCounter + 1);
        }, 1000);
    };

    const stopCounter = () => {
        if (intervalRef.current) {
            clearInterval(intervalRef.current);
            intervalRef.current = null;
            setCounter(0)
        }
    };

    React.useEffect(() => {
        if (counter === 5) {
            stopCounter();
            props.onClick();
        }
    }, [counter]);

    return <div style={{ height: "50px", width: "50px", position: "fixed", left: 0, top: 0 }}
        onMouseDown={startCounter}
        onMouseUp={stopCounter}
        onTouchStart={startCounter}
        onTouchCancel={stopCounter}
        onMouseLeave={stopCounter}
    />
}


// WEBPACK FOOTER //
// ./src/components/DebugWindow/ButtonTimer.tsx